/**
 * Locofast brand identity — mark + wordmark side by side.
 *
 *   variant="mark"     → weave monogram only
 *   variant="wordmark" → "Locofast" text only
 *   variant="full"     → mark + wordmark (default)
 *
 * `size` = mark height in px; wordmark shares the same height.
 * `tone` = "brand" (blue) | "white" (for dark backgrounds)
 */
const MARK_SRC = {
  brand: "/brand/locofast-mark.png",
  white: "/brand/locofast-mark-white.png",
};

/** Wordmark aspect from public/brand/locofast-wordmark.png */
const WORD_ASPECT = 899 / 170;

const LocofastLogo = ({
  variant = "full",
  size = 32,
  tone = "brand",
  className = "",
}) => {
  const markSrc = MARK_SRC[tone] || MARK_SRC.brand;
  const wordFilter = tone === "white" ? { filter: "brightness(0) invert(1)" } : undefined;

  const markImg = (
    <img
      src={markSrc}
      alt={variant === "mark" ? "Locofast" : ""}
      width={size}
      height={size}
      className={variant === "mark" ? className : undefined}
      style={{ display: "block", flexShrink: 0, objectFit: "contain" }}
      draggable={false}
    />
  );

  if (variant === "mark") return markImg;

  const wordHeight = Math.round(size * 0.72);
  const wordWidth = Math.round(wordHeight * WORD_ASPECT);
  const word = (
    <img
      src="/brand/locofast-wordmark.png"
      alt=""
      width={wordWidth}
      height={wordHeight}
      style={{
        display: "block",
        height: wordHeight,
        width: "auto",
        objectFit: "contain",
        ...wordFilter,
      }}
      draggable={false}
    />
  );

  if (variant === "wordmark") {
    return (
      <span className={className} aria-label="Locofast" role="img">
        {word}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-2.5 ${className}`}
      style={{ lineHeight: 0 }}
      aria-label="Locofast"
      role="img"
    >
      {markImg}
      {word}
    </span>
  );
};

export default LocofastLogo;
